import { chakra, Text } from "@chakra-ui/react";
import { Box, Button } from "@chakra-ui/react";

export const SectionContainer = chakra(Box, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    gap: "26px",
    padding: "32px 24px",
  },
});

export const SectionHeader = chakra(Box, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
});

export const Card = chakra(Box, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "16px",
    border: "1px solid #A7B2BA",
    padding: "24px",
    gap: "24px",
  },
});

export const CardTitle = chakra(Text, {
  baseStyle: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#5C6670",
  },
});

export const CardOptionsContainer = chakra(Box, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
});

export const OptionRow = chakra(Box, {
  baseStyle: {
    display: "flex",
    gap: "16px",
    padding: "6px 10px",
    flexDirection: "row",
    borderRadius: "8px",
    _hover: {
      backgroundColor: "#F4F4F4",
    },
  },
});

export const ChapterBox = chakra(Box, {
  baseStyle: {
    border: "1px solid #a7b2ba",
    borderRadius: "8px",
    padding: "16px",
    backgroundColor: "#fff",
  },
});

// EnrollmentMonthBox: Use _selected prop for selected styling, since chakra() does not support custom props directly.
export const EnrollmentMonthBox = chakra(Box, {
  baseStyle: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    borderRadius: "16px",
    padding: "2px 8px",
    background: "#f0f9ff",
    fontWeight: 400,
    color: "#2F2F34",
    gap: "8px",
    transition: "border 0.2s, color 0.2s, font-weight 0.2s",
  },
});

export const NavigationButtonsBox = chakra(Box, {
  baseStyle: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "24px",
    paddingBottom: "24px",
  },
});
